import { render, staticRenderFns } from "./HeaderUserAreaMobile.vue?vue&type=template&id=06d35481&scoped=true&"
import script from "./HeaderUserAreaMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderUserAreaMobile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserAreaMobile.vue?vue&type=style&index=0&id=06d35481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d35481",
  null
  
)

export default component.exports